<template>
  <ApplicationsRow two-columns>
    <AhOvApplicationCard
      :no-top-left-border="activeCurrentTenantIndex === 0"
      :no-top-right-border="
        activeCurrentTenantIndex === currentTenants.length - 1
      "
    >
      <template #top-content>
        <GenericH4>
          {{
            currentTenants.length > 1
              ? activeCurrentTenant.index === 0
                ? 'Överlåtare 1'
                : 'Överlåtare 2'
              : 'Överlåtaren'
          }}
        </GenericH4>
        <PersonCard
          :name="`${activeCurrentTenant.name} ${
            activeCurrentTenant.protectedIdentity ? '❗️' : ''
          }`"
        >
          <!-- <template #name-icon>
            <LegalIcon v-if="activeCurrentTenantLegalRef" color="#e00201" />
          </template> -->
        </PersonCard>
        <MemberSelector
          v-if="currentTenants.length > 1"
          :items="
            currentTenants.map((tenant, index) => ({
              ...tenant,
              label: tenant.name,
              protectedIdentity: tenant.protectedIdentity
              //legalRef: getLegalRef(application, tenant.ssn)
            }))
          "
          :active-index="activeCurrentTenantIndex"
          @selectItemIndex="selectCurrentTenantIndex"
        />
      </template>
      <h3 class="name capitalize-first">
        <template v-if="currentTenantCompanyInfo">{{
          currentTenantCompanyInfo.name
        }}</template>
        <template v-else>{{ activeCurrentTenant.name }}</template>
      </h3>
      <ul class="apartment-info">
        <template v-if="currentTenantCompanyInfo">
          <li><b>Orgnr.:</b> {{ activeCurrentTenant.organizationNumber }}</li>
          <li><b>Kontaktperson:</b> {{ activeCurrentTenant.name }}</li>
        </template>
        <li><b>Personnr.:</b> {{ activeCurrentTenant.ssn }}</li>
        <li><b>E-post:</b> {{ activeCurrentTenant.email }}</li>
        <li>
          <b>Telefonnr.:</b>
          {{ activeCurrentTenant.phone }}
        </li>
        <li>
          <b>Relation till tilltänkta hyresgästen:</b>
          {{ readableRelationship(reason.relationship) }}
        </li>
      </ul>
      <template v-if="activeCurrentTenant.protectedIdentity">
        <br />
        <h4 class="protectedIdentity-color" style="line-height: 1.6">
          Skyddad identitet
        </h4>
        <p>
          <b>{{ activeCurrentTenant.name }}</b> har skyddad identitet
        </p>
      </template>
      <template v-if="activeCurrentTenant.fullmaktName">
        <br />
        <h3 class="name capitalize-first">Fullmaktshavaren</h3>
        <ul class="apartment-info">
          <li>
            <b>Namn:</b>
            {{ activeCurrentTenant.fullmaktName }}
          </li>
          <li>
            <b>Personnr.:</b>
            {{ activeCurrentTenant.ssn }}
          </li>
          <li>
            <b>E-post:</b>
            {{ activeCurrentTenant.email }}
          </li>
          <li>
            <b>Telefonnr.:</b>
            {{ activeCurrentTenant.phone }}
          </li>
          <li>
            <b>Skyddad identitet:</b>
            {{ activeCurrentTenant.fullmaktProtectedIdentity ? 'Ja' : 'Nej' }}
          </li>
        </ul>
      </template>
      <!-- <template v-if="activeCurrentTenantLegalRef">
        <br />
        <LegalRef
          :name="activeCurrentTenantLegalRef.name"
          :url="activeCurrentTenantLegalRef.url"
        />
      </template> -->
      <hr class="divider" />
      <h3 class="name capitalize-first">Lägenheten</h3>
      <ul class="apartment-info">
        <li><b>Adress:</b> {{ apartment.address }}</li>
        <li><b>Postnr.:</b> {{ apartment.postalCode }}</li>
        <li><b>Ort:</b> {{ apartment.city }}</li>
        <li><b>Objektnr./kontraktsnr.:</b> {{ apartment.objectNumber }}</li>
        <li><b>Lägenhetsnr.:</b> {{ apartment.apartmentNumber }}</li>
        <li><b>Nuvarande hyra:</b> {{ apartment.rent }}</li>
        <li><b>Antal rum:</b> {{ apartment.rooms }}</li>
        <li><b>Storlek i kvm:</b> {{ apartment.sqm }}</li>
        <li>
          <b>Innehaft sedan:</b>
          {{
            new Date(apartment.contractStartDate).toLocaleDateString('sv-SE')
          }}
        </li>
      </ul>
      <hr class="divider" />
      <OvApplicationCheckboxes
        :files="application.files"
        :application="application"
        :application-id="application.id"
        :checked-files="application.checkedFiles"
        :other-checkboxes="otherCheckboxes"
        :application-status="application.landlordStatus"
        @openFile="$emit('openFile', $event)"
        @checksChange="$emit('checksChange', $event)"
        @selectComment="$emit('selectComment', $event)"
      />
      <br />
      <div class="card-content">
        <GenericH4>Skäl</GenericH4>
        <p>{{ getReasonText }}</p>
      </div>
      <br />
      <div class="card-content">
        <GenericH4>Anledning</GenericH4>
        <p>{{ application.reason.text }}</p>
      </div>
      <template v-if="hasNewAddress">
        <br />
        <div class="card-content">
          <GenericH4>Flyttadress</GenericH4>
          <p>{{ application.reason.newAddress }}</p>
        </div>
      </template>
    </AhOvApplicationCard>
    <AhOvApplicationCard
      :no-top-left-border="activeSecondaryTenantIndex === 0"
      :no-top-right-border="
        activeSecondaryTenantIndex === secondaryTenants.length - 1
      "
    >
      <template #top-content>
        <GenericH4>
          {{
            secondaryTenants.length > 1
              ? activeSecondaryTenant.index === 0
                ? 'Övertagare 1'
                : 'Övertagare 2'
              : 'Övertagaren'
          }}
        </GenericH4>
        <PersonCard
          :name="`${activeSecondaryTenant.name} ${
            activeSecondaryTenant.protectedIdentity ? '❗️' : ''
          }`"
        >
          <!-- <template #name-icon>
            <LegalIcon v-if="activeSecondaryTenantLegalRef" color="#e00201" />
          </template> -->
        </PersonCard>
        <MemberSelector
          v-if="secondaryTenants.length > 1"
          :items="
            secondaryTenants.map((tenant, index) => ({
              ...tenant,
              label: tenant.name,
              protectedIdentity: tenant.protectedIdentity
              //legalRef: getLegalRef(application, tenant.ssn)
            }))
          "
          :active-index="activeSecondaryTenantIndex"
          @selectItemIndex="selectSecondaryTenantIndex"
        />
      </template>
      <h3 class="name capitalize-first">
        <template v-if="secondaryTenantCompanyInfo">{{
          secondaryTenantCompanyInfo.name
        }}</template>
        <template v-else>{{ activeSecondaryTenant.name }}</template>
      </h3>
      <ul class="apartment-info">
        <template v-if="secondaryTenantCompanyInfo">
          <li><b>Orgnr.:</b> {{ activeSecondaryTenant.organizationNumber }}</li>
          <li><b>Kontaktperson:</b> {{ activeSecondaryTenant.name }}</li>
        </template>
        <li><b>Personnr.:</b> {{ activeSecondaryTenant.ssn }}</li>
        <li><b>E-post:</b> {{ activeSecondaryTenant.email }}</li>
        <li>
          <b>Telefonnr.:</b>
          {{ activeSecondaryTenant.phone }}
        </li>
        <li><b>Adress:</b> {{ activeSecondaryTenant.address }}</li>
        <li><b>Postnr.:</b> {{ activeSecondaryTenant.postalCode }}</li>
        <li><b>Ort:</b> {{ activeSecondaryTenant.city }}</li>
        <li v-if="activeSecondaryTenant.residentSince">
          <b>Inneboende sedan:</b>
          {{
            new Date(activeSecondaryTenant.residentSince).toLocaleDateString(
              'sv-SE'
            )
          }}
        </li>
        <li><b>Totalt antal vuxna:</b> {{ secondaryTenants[0].adultCount }}</li>
        <li><b>Totalt antal barn:</b> {{ secondaryTenants[0].childCount }}</li>
      </ul>
      <template v-if="activeSecondaryTenant.protectedIdentity">
        <br />
        <h4 class="protectedIdentity-color" style="line-height: 1.6">
          Skyddad identitet
        </h4>
        <p>
          <b>{{ activeSecondaryTenant.name }}</b> har skyddad identitet
        </p>
      </template>
      <template v-if="activeSecondaryTenant.fullmaktName">
        <br />
        <h3 class="name capitalize-first">Fullmaktshavaren</h3>
        <ul class="apartment-info">
          <li>
            <b>Namn:</b>
            {{ activeSecondaryTenant.fullmaktName }}
          </li>
          <li>
            <b>Personnr.:</b>
            {{ activeSecondaryTenant.ssn }}
          </li>
          <li>
            <b>E-post:</b>
            {{ activeSecondaryTenant.email }}
          </li>
          <li>
            <b>Telefonnr.:</b>
            {{ activeSecondaryTenant.phone }}
          </li>
          <li>
            <b>Skyddad identitet:</b>
            {{ activeSecondaryTenant.fullmaktProtectedIdentity ? 'Ja' : 'Nej' }}
          </li>
        </ul>
      </template>
      <!-- <template v-if="activeSecondaryTenantLegalRef">
        <br />
        <LegalRef
          :name="activeSecondaryTenantLegalRef.name"
          :url="activeSecondaryTenantLegalRef.url"
        />
      </template> -->
      <hr class="divider" />
      <OvApplicationCheckboxes
        :files="application.files"
        :application="application"
        :application-id="application.id"
        :checked-files="application.checkedFiles"
        :application-status="application.landlordStatus"
        :is-transferor="false"
        @openFile="$emit('openFile', $event)"
        @checksChange="$emit('checksChange', $event)"
        @selectComment="$emit('selectComment', $event)"
      />
    </AhOvApplicationCard>
  </ApplicationsRow>
</template>
<script>
import { ovReasonText } from '@/utils/ovUtils';
//import { getLegalRef } from '@/utils/legalRef';

import PersonCard from '@/components/PersonCard.vue';
import MemberSelector from '@/components/MemberSelector.vue';
import OvApplicationCheckboxes from '@/components/OvApplicationCheckboxes.vue';
import AhOvApplicationCard from '@/components/AhOvApplicationCard.vue';
import ApplicationsRow from './ApplicationsRow.vue';
import GenericH4 from '@/components/GenericH4.vue';
//import LegalIcon from '@/components/Icons/LegalIcon.vue';
//import LegalRef from '@/components/LegalRef.vue';

export default {
  components: {
    PersonCard,
    ApplicationsRow,
    AhOvApplicationCard,
    OvApplicationCheckboxes,
    MemberSelector,
    GenericH4
    //LegalIcon,
    //LegalRef
  },
  props: {
    application: {
      type: Object,
      required: true
    },
    otherCheckboxes: {
      type: Array,
      required: true
    }
  },
  emits: ['checksChange', 'openFile', 'selectComment'],

  data() {
    return {
      ovReasonText,
      activeCurrentTenantIndex: 0,
      activeSecondaryTenantIndex: 0
      //getLegalRef
    };
  },
  computed: {
    hasNewAddress() {
      return Object.prototype.hasOwnProperty.call(
        this.application?.reason || {},
        'newAddress'
      );
    },
    secondaryTenants() {
      return this.application.secondaryTenants;
    },
    currentTenants() {
      return this.application.currentTenants;
    },
    activeCurrentTenant() {
      return this.currentTenants[this.activeCurrentTenantIndex];
    },
    // activeCurrentTenantLegalRef() {
    //   const legalRefUrl = this.getLegalRef(
    //     this.application,
    //     this.activeCurrentTenant.ssn
    //   );
    //   if (!legalRefUrl) {
    //     return null;
    //   }
    //   return {
    //     name: this.activeCurrentTenant.name,
    //     url: legalRefUrl
    //   };
    // },
    activeSecondaryTenant() {
      return this.secondaryTenants[this.activeSecondaryTenantIndex];
    },
    // activeSecondaryTenantLegalRef() {
    //   const legalRefUrl = this.getLegalRef(
    //     this.application,
    //     this.activeSecondaryTenant.ssn
    //   );
    //   if (!legalRefUrl) {
    //     return null;
    //   }
    //   return {
    //     name: this.activeSecondaryTenant.name,
    //     url: legalRefUrl
    //   };
    // },
    getReasonText() {
      return this.ovReasonText(this.reason);
    },
    apartment() {
      return this.application.apartment;
    },
    reason() {
      return this.application.reason;
    },
    currentTenantCompanyInfo() {
      return this.getCompanyInfo(this.currentTenants[0].organizationNumber);
    },
    secondaryTenantCompanyInfo() {
      return this.getCompanyInfo(this.secondaryTenants[0].organizationNumber);
    }
  },
  methods: {
    getCompanyInfo(orgNr) {
      return this.application.companies[orgNr];
    },
    selectSecondaryTenantIndex(index) {
      this.activeSecondaryTenantIndex = index;
    },
    selectCurrentTenantIndex(index) {
      this.activeCurrentTenantIndex = index;
    },
    readableRelationship(relationship) {
      switch (relationship) {
        case 'barn':
          return 'Barn';
        case 'makeMaka':
          return 'Make/maka';
        case 'sambo':
          return 'Sambo';
        case 'slakting':
          return 'Släkting';
        case 'syskon':
          return 'Syskon';
        case 'annat':
          return 'Annat';
        default:
          return relationship;
      }
    }
  }
};
</script>
<style scoped>
.divider {
  background-color: #e4e5e8;
  margin: 2rem 0;
  border: none;
  height: 1px;
}

.apartment-info li {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.6;
}
.apartment-info li b {
  font-weight: 600;
}
</style>
